function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      fill="white"
    >
      <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80z" />
    </svg>
  );
}

export default PlusIcon;
